import { Asset } from "./asset";
import { CompanyDto } from "./companyDto";
import { ProductClassificationDto } from "./ProductClassificationDto";

export class EditAssetCommand {
  cid?: string | null;
  serialNumber?: string | null;
  quantity?: number | null;//missing in asset api
  manufacturingDate?: string | null;
  commissioningDate?: string | null;
  description?: string | null;
  manufacturingOrder?: string | null;//missing in asset api
  deliveryDate?: string | null;
  manufacturerAbacus?: string | null;//missing in asset api
  createdBy?: string | null;
  createdDate?: Date | null;
  modifiedBy?: string | null;
  modifiedDate?: Date | null;
  factoryWarrantyStart?: string | null;
  factoryWarrantyEnd?: string | null;
  customerWarrantyStart?: string | null;
  customerWarrantyEnd?: string | null;
  referenceNumber?: string | null;//missing in asset api
  lifeCyclePhase?: string | null;
  nextLifeCyclePhase?: string | null;
  nextLifeCyclePhaseDate?: string | null;
  parentAssetId?: string | null;
  salesOrder?: string | null;
  salesOrderItem?: string | null;
  deviceType?: string | null;
  extendedWarrantyStart?: string | null;
  extendedWarrantyEnd?: string | null;
  channelPartner?: CompanyDto | null;
  manufacturer?: CompanyDto | null;
  receivingCompany?: CompanyDto | null;
  productClassification?: ProductClassificationDto | null;

  public static fromAsset(asset: Asset): EditAssetCommand {
    const editAssetCommand = new EditAssetCommand();
    editAssetCommand.cid = asset.cid;
    editAssetCommand.serialNumber = asset.serialNumber;
    editAssetCommand.manufacturingDate = asset.manufacturingDate;
    editAssetCommand.commissioningDate = asset.commissioningDate;
    editAssetCommand.description = asset.description;
    editAssetCommand.deliveryDate = asset.deliveryDate;
    editAssetCommand.createdBy = asset.createdBy;
    editAssetCommand.createdDate = asset.createdDate;
    editAssetCommand.modifiedBy = asset.modifiedBy;
    editAssetCommand.modifiedDate = asset.modifiedDate;
    editAssetCommand.factoryWarrantyStart = asset.factoryWarrantyStart;
    editAssetCommand.factoryWarrantyEnd = asset.factoryWarrantyEnd;
    editAssetCommand.customerWarrantyStart = asset.customerWarrantyStart;
    editAssetCommand.customerWarrantyEnd = asset.customerWarrantyEnd;
    editAssetCommand.lifeCyclePhase = asset.lifeCyclePhase;
    editAssetCommand.nextLifeCyclePhase = asset.nextLifeCyclePhase;
    editAssetCommand.nextLifeCyclePhaseDate = asset.nextLifeCyclePhaseDate;
    editAssetCommand.parentAssetId = asset.parentAssetId;
    editAssetCommand.salesOrder = asset.salesOrder;
    editAssetCommand.salesOrderItem = asset.salesOrderItem;
    editAssetCommand.extendedWarrantyStart = asset.extendedWarrantyStart;
    editAssetCommand.extendedWarrantyEnd = asset.extendedWarrantyEnd;
    editAssetCommand.channelPartner = asset.channelPartner;
    editAssetCommand.manufacturer = asset.manufacturer;
    editAssetCommand.receivingCompany = asset.receivingCompany;
    editAssetCommand.deviceType = asset.deviceType;

    return editAssetCommand;
  }
}
